import React from 'react';
import { motion } from 'framer-motion';

const ProjectChallenge = () => {
  return (
    <section className="py-24 bg-white">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          {/* Challenge Description */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="mb-16"
          >
            <span className="inline-block text-accent mb-4">The Challenge</span>
            <h2 className="text-3xl md:text-4xl font-display font-semibold text-gray-900 mb-8">
              From World Expo to Smart City
            </h2>
            <div>
              <p className="text-lg text-gray-600 mb-8 leading-relaxed">
                When Expo 2020 Dubai concluded, it left behind an extraordinary legacy—a state-of-the-art 
                438-hectare site that hosted 25 million visits across 192 country pavilions. This 
                presented both an opportunity and a challenge: how to transform this massive 
                achievement into a sustainable, vibrant smart city of the future.
              </p>
              <p className="text-lg text-gray-600 leading-relaxed">
                The challenge was to create a digital ecosystem that would not only preserve the 
                spirit of innovation and global connection that defined Expo 2020 but also evolve 
                it into a living, breathing city of the future.
              </p>
            </div>
          </motion.div>

          {/* Context */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="grid lg:grid-cols-2 gap-12"
          >
            <div>
              <h3 className="text-2xl font-display font-semibold text-gray-900 mb-6">
                The Context
              </h3>
              <p className="text-lg text-gray-600 mb-6 leading-relaxed">
                Expo City Dubai represents Dubai's vision for the future of urban living—a 
                blueprint for sustainable cities that harmoniously blend technology, community, 
                and environmental consciousness.
              </p>
              <p className="text-lg text-gray-600 leading-relaxed">
                The transformation from a world exposition site to a permanent smart city 
                required a digital solution that would serve both visitors and residents, 
                making the city's vast offerings accessible and engaging.
              </p>
            </div>
            <div>
              <h3 className="text-2xl font-display font-semibold text-gray-900 mb-6">
                Key Requirements
              </h3>
              <ul className="space-y-4">
                <li className="flex items-start gap-4">
                  <div className="w-8 h-8 rounded-full bg-accent/10 flex items-center justify-center flex-shrink-0 mt-1">
                    <span className="text-accent font-medium">01</span>
                  </div>
                  <p className="text-lg text-gray-600">
                    Create an intuitive digital companion that enhances the experience for both 
                    international visitors and the local community
                  </p>
                </li>
                <li className="flex items-start gap-4">
                  <div className="w-8 h-8 rounded-full bg-accent/10 flex items-center justify-center flex-shrink-0 mt-1">
                    <span className="text-accent font-medium">02</span>
                  </div>
                  <p className="text-lg text-gray-600">
                    Develop smart navigation solutions to help users explore the city's numerous 
                    attractions and facilities effortlessly
                  </p>
                </li>
                <li className="flex items-start gap-4">
                  <div className="w-8 h-8 rounded-full bg-accent/10 flex items-center justify-center flex-shrink-0 mt-1">
                    <span className="text-accent font-medium">03</span>
                  </div>
                  <p className="text-lg text-gray-600">
                    Implement a dynamic event system that keeps users informed and engaged with 
                    the city's vibrant calendar of activities
                  </p>
                </li>
              </ul>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default ProjectChallenge;